// These files will rely on jQuery being available without the need of an import
// or importing jquery and getting the value from the global.
// these are respectively managed thanks to webpackeer configuration
// of "ProvidePlugin" and "externals"


require('jquery-match-height');
require('jquery-ujs');
